'use strict';

var novicell = novicell || {};

novicell.checkout = novicell.checkout || function () {
    var radioButtons = null;
    var deliveryAddressForm = null;
    var deliveryAddressFields=null;
    function init() {
        
        deliveryAddressForm = document.querySelector('.o-checkout__deliveryAddress');
        if(deliveryAddressForm != null){
            initDeliveryAddress();
        }

    }
    function initDeliveryAddress() {
        deliveryAddressFields = deliveryAddressForm.querySelectorAll('input');
        radioButtons = document.querySelectorAll('input[name=useSameAddressForDelivery]');
        if(radioButtons.length){
            for(var i = 0; i < radioButtons.length ; i++){
                radioButtons[i].addEventListener('click',deliveryAddressCheck);
            }
            deliveryAddressCheck();
        }
    }

    function deliveryAddressCheck(){
        var disabledStatus=true;
        for(var i = 0 ; i < radioButtons.length ; i++){
            if(radioButtons[i].checked){
                if(radioButtons[i].id == 'sameAddressForDeliveryYes'){
                    deliveryAddressForm.classList.remove('o-checkout__deliveryAddress--show');
                }else{
                    deliveryAddressForm.classList.add('o-checkout__deliveryAddress--show');
                    disabledStatus = false;
                }
                for(var j = 0; j < deliveryAddressFields.length; j++){
                    deliveryAddressFields[j].disabled = disabledStatus;
                }
            }
        }
    }
    
    return {
        init: init
    };
    
}();
